// extracted by mini-css-extract-plugin
module.exports = {"root":"PatternAutocomplete_root__2EJQ0","list":"PatternAutocomplete_list__3HrPT"};